import { render, staticRenderFns } from "./textbox.vue?vue&type=template&id=45bc3b83&scoped=true"
import script from "./textbox.vue?vue&type=script&lang=js"
export * from "./textbox.vue?vue&type=script&lang=js"
import style0 from "./textbox.vue?vue&type=style&index=0&id=45bc3b83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bc3b83",
  null
  
)

export default component.exports